const isLive = process.env.REACT_APP_USE_STRIPE_LIVE === "true";

const SDK = {
  BASE_URL: isLive
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_DEV_LIFE,

  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,

  STRIPE_KEY: isLive
    ? process.env.REACT_APP_STRIPE_KEY_LIVE
    : process.env.REACT_APP_STRIPE_KEY_TEST,

  FB_PIXEL_ID: process.env.REACT_APP_FB_PIXEL_ID,
  TIK_TOK_PIXEL_ID: process.env.REACT_APP_TIK_TOK_PIXEL_ID,
  X_PIXEL_ID: process.env.REACT_APP_X_PIXEL_ID,
  FB_CURRNECY: "USD",
  mailchimpPriceTag: "gift",
  FB_PRICE: "19",
  FB_DISOUNT_PRICE: "0",
  APPLE_PAY_PRICE: 1900,
  APPLE_PAY_CURRENCY: "usd",

  REGION_CONFIG: {
    uk: {
      currency: "gbp",
      price: 1900,
      countryCode: "GB",
      currSymbol: "£",
      text: "",
    },
    eu: {
      currency: "eur",
      price: 1900,
      countryCode: "DE",
      currSymbol: "€",
      text: "",
    },
    us: {
      currency: "usd",
      price: 1900,
      countryCode: "US",
      currSymbol: "$",
      text: " Prices are in USD.",
    },
  },
};

export default SDK;
